import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffPapersIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      current: '',
      next: '',
      previous: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      var now = new Date();
      var year = now.getFullYear();
      var reference = year;
      this.setState({loaded: 2}, this.loadData(reference));
    }
  }

  loadData(reference) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/papeletas/portal/' + reference, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next, array_hide: responseJson.data.array_hide});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/papeleta/editar/' + cell;

    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var fira_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Papeletas.ListaDePapeletas.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/papeleta/' + fira_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(fira_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(fira_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == fira_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  next() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.next);
  }

  previous() {
    this.setState({overlay: {message: '', type: '', status: 'open'}});
    this.loadData(this.state.previous);
  }


  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-primary" onClick={this.previous}><i className="fa fa-fw fa-chevron-left"></i> {this.state.previous}</button>
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.current}</h3>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-primary" onClick={this.next}>{this.state.next} <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
        
      <h3 className="page-title">{this.locale.Papeletas.ListaDePapeletas.titulo} </h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Papeletas.ListaDePapeletas.tabela.semPapeletas}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Papeletas.ListaDePapeletas.tabela.ID}</TableHeaderColumn>

        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='240'>{this.locale.Papeletas.ListaDePapeletas.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Papeletas.ListaDePapeletas.tabela.Matricula}</TableHeaderColumn>
        <TableHeaderColumn dataField="month" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Papeletas.ListaDePapeletas.tabela.Referencia}</TableHeaderColumn>
        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Papeletas.ListaDePapeletas.tabela.Status}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Papeletas.ListaDePapeletas.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffPapersIndex;



// WEBPACK FOOTER //
// ./src/Components/StaffPapers/StaffPapersIndex.js